define('views/pages/ContactPageView',['underscore', 'backbone', 'jquery', 'PageView', 'app', 'testEmail', 'models/ContactModel','SelectView','InputView','template!contact','router','UrlFactory',

    'models/ContactCollection'
], function (_, Backbone, $, PageView, app, testEmail, ContactModel,SelectView,InputView,contactTemplate, router, UrlFactory, contactCollection) {


    var contacts,
        currentContact;

    return PageView.extend({
        pageName: 'Contact',
        events: {
            'submit #contactForm': 'submitForm'
        },

        initialize: function (options) {



            var view = this,
                url = Backbone.history.getFragment().split('/'),
                slug = url.pop();


            view.listenTo(app, 'contactFailReset', view.contactFailReset);
            view.listenTo(app, 'contactSuccessReset', view.contactSuccessReset);
            contacts = new contactCollection();

            if(options.microtemplateStart){
                view.microtemplateStart = options.microtemplateStart;
            }

            function onSync() {
                currentContact = contacts.findWhere({link_rewrite: slug});
                if(!currentContact){
                    // si on identifie pas le slug on utilise le premier
                    currentContact = contacts.first();
                }
                view.render(true);
            }
            view.listenToOnce(contacts,'sync',onSync);
            contacts.fetch();
            // PageView constructor heritage

            PageView.prototype.initialize.apply(view,arguments);

        },
        contactSuccessReset:function () {
            var view = this;

            view.$('#contactForm')[0].reset();

            view.$('#contactForm #sendYourOpinion').removeClass('loading');
            view.$('#sendYourOpinion').prop('disabled', false);

        },
        contactFailReset:function () {
            var view = this;



            view.$('#contactForm #sendYourOpinion').removeClass('loading');
            view.$('#sendYourOpinion').prop('disabled', false);

        },
        initialRender:function(){},
        microtemplate:function(options){
            this.pageOptions = _.defaults(options,{});;
            this.toggleForm(options.subpage);
        },
        render:function(microtemplating){
            var view = this;
            var contactCollection = contacts,
                stores = app.getStores().clone();

            // trie les boutiques par code postal
            stores.comparator = function(store){
                return store.formatPostcode();
            };
            stores.sort();

            if(microtemplating){
                view.$el.html(contactTemplate({
                    customer:app.getCustomer(),
                    contactCollection: contactCollection,
                    currentContact: currentContact,
                    stores: stores
                }));
                view.initializeLinksOfPage();
            }

            view.attachViews(SelectView.initializeSelectsOfView(view));
            view.attachViews(InputView.initializeInputsOfView(view));

            view.$('.inline-loader').hide();
            view.$('.form-container').addClass('active');

            view.delegateEvents();
        },
        toggleForm: function (rewrite) {
            //e.preventDefault();
            var view = this,
                current = contacts.findWhere({link_rewrite: rewrite});
            if(current){
                currentContact = current;
                view.render(true);
                app.$htmlBody.animate({scrollTop:view.$('section.form').offset().top - $('.site-header').outerHeight()});
            }
        },
        submitForm: function (e) {
            e.preventDefault();
            var view = this,
                // translation factorisation
                contactTrContext = 'Contact',
                pleaseSelectMessage = 'Merci de saisir %s',
                pleaseChooseMessage = 'Merci de choisir %s';

            function fieldVal(name){
                return view.$('[name='+name+']').val();
            }
            // translation factorisation warning
            function warningMessage(field,pleaseMessage){
                if(!pleaseMessage) pleaseMessage = pleaseSelectMessage; // default please message
                app.bottomNotice(t(pleaseMessage,contactTrContext,t(field,contactTrContext)));
            }

            var email = fieldVal('email'),
                commandeId = fieldVal('id_order'),
                storeId = fieldVal('id_store'),
                lastName = fieldVal('lastname'),
                firstName = fieldVal('firstname'),
                postCode = fieldVal('postcode'),
                city = fieldVal('city'),
                phone = fieldVal('phone'),
                message = fieldVal('message'),
                need_order = fieldVal('need_order') == 'true';
            if ((email == "") || (testEmail(email) == false)) {
                warningMessage('un email valide');
            }else if (need_order && (commandeId == "")) {
                warningMessage('le numéro de votre commande');
            }else if (storeId == "" || storeId == 0) {
                warningMessage('votre boutique',pleaseChooseMessage);
            }else if (lastName == "") {
                warningMessage('votre nom');
            }else if (firstName == "") {
                warningMessage('votre prénom');
            }else if (postCode == "") {
                warningMessage('votre code postal');
            }else if (city == "") {
                warningMessage('votre ville');
            }else if (message == "") {
                warningMessage('votre message');
            }else{


              view.$('#contactForm #sendYourOpinion').addClass('loading');
                view.$('#sendYourOpinion').prop('disabled', true);
                //loading

                currentContact.submit(
                    email,
                    commandeId,
                    storeId,
                    lastName,
                    firstName,
                    postCode,
                    city,
                    phone,
                    message,
                    storeId
                );
            }


        }


    })

});
